import { emptySplitApi as api } from "./emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getUsersList: builder.query<[], void>({
      query: () => {
        return {
          url: `/api/user/already-registered`,
        };
      },
    }),
    getMeInfo: builder.query<[], any>({
      query: (queryArg) => {
        return {
          url: `/api/user/me`,
          params: queryArg,
        };
      },
    }),
    createUser: builder.mutation<any, Partial<[]>>({
      query: (item) => {
        return {
          url: `/api/user`,
          method: "POST",
          body: item,
        };
      },
    }),
    createUserWithAcceptedTerms: builder.mutation<any, Partial<[]>>({
      query: (item) => {
        return {
          url: `/api/user/accepted-terms`,
          method: "POST",
          body: { ...item, acceptedTerms: true },
        };
      },
    }),

      updateTermsOptIn: builder.mutation<any, Partial<[]>>({
      query: (item) => {
        return {
          url: `/api/user/update-terms-optin`,
          method: "POST",
          body: { ...item },
        };
      },
    }),

    updateEmailNotification: builder.mutation<any, Partial<UsersApiArg>>({
      query: (item) => {
        return {
          url: `/api/user/update-email-notification`,
          method: "PUT",
          body: item,
        };
      },
    }),
    updateAISettings: builder.mutation<any, { userId: string; allowAITracks: boolean }>({
      query: (item) => {
        return {
          url: `/api/user/update-ai-settings`,
          method: "PUT",
          body: item,
        };
      },
    }),
    getProfileStats: builder.query<any, { userId: string }>({
      query: ({ userId }) => ({
        url: `/api/user/profile-stats`,
        params: { userId },
      }),
    }),
    resolveReferralSlug: builder.query<any, { slug: string }>({
      query: ({ slug }) => ({
        url: `/api/user/resolve-referral-slug/${slug}`,
      }),
    }),
    updateUniqueIdentifier: builder.mutation<any, { userId: string; uniqueIdentifier: string | null }>({
      query: (item) => ({
        url: `/api/user/update-unique-identifier`,
        method: "PUT",
        body: item,
      }),
    }),
    updateUniqueCuratorIdentifier: builder.mutation<any, { userId: string; uniquecuratoridentifier: string | null }>({
      query: (item) => ({
        url: `/api/user/update-unique-curator-identifier`,
        method: "PUT",
        body: item,
      }),
    }),
  }),
});
export { injectedRtkApi as enhancedApi };

export type UsersApiArg = {
  id?: number;
  spotifyId?: any;
  emailReceiver?: boolean;
};
export const {
  useGetUsersListQuery,
  useGetMeInfoQuery,
  useCreateUserMutation,
  useCreateUserWithAcceptedTermsMutation,
    useUpdateTermsOptInMutation,
  useUpdateEmailNotificationMutation,
  useGetProfileStatsQuery,
  useUpdateAISettingsMutation,
  useResolveReferralSlugQuery,
  useUpdateUniqueIdentifierMutation,
  useUpdateUniqueCuratorIdentifierMutation,
} = injectedRtkApi;
